<mat-card
  [class.provisional]="chainStatus?.status === 'provisional' && !isPartiallyLockedChain() && !isMergedChain()"
  [class.definitive]="chainStatus?.status === 'definitive'"
  [class.selected_for_transplantation]="chainStatus?.status === 'selected_for_transplantation'"
  [class.transplanted]="chainStatus?.status === 'transplanted'"
  [class.cancelled]="chainStatus?.status === 'cancelled'"
  [class.unselected_for_transplantation]="chainStatus?.status === 'unselected_for_transplantation'"
  [class.reselected]="chainStatus?.status === 'selected_for_transplantation' && chainStatus?.wasPreviouslySelected"
  class="maincard">
  <mat-list>
    <mat-list-item>
      <div class="stretch flex-row align-center">
        <h2 class="flex-fill" [class.new-chain]="isNewChain">Chain {{ matchRunNumber }}:{{ chainNumber }}</h2>
        <!-- Status indicator icons -->
        <!-- Merged chain icon (highest priority) -->
        <mat-icon *ngIf="isMergedChain()" class="status-icon partial-lock-icon" matTooltip="Partially locked">lock_clock</mat-icon>

        <!-- Special lock icon for partial lock -->
        <mat-icon *ngIf="isPartiallyLockedChain()" class="status-icon partial-lock-icon" [class.new-indicator]="isChainStatusNew" matTooltip="Partially locked">lock_clock</mat-icon>

        <!-- Regular status icons -->
        <mat-icon *ngIf="chainStatus?.status === 'provisional' && !isMergedChain() && !isPartiallyLockedChain()" class="status-icon provisional-icon" [class.new-indicator]="isChainStatusNew" matTooltip="Locked match - Chain is locked and persists in new match runs">lock</mat-icon>
        <mat-icon *ngIf="chainStatus?.status === 'definitive'" class="status-icon definitive-icon" [class.new-indicator]="isChainStatusNew" matTooltip="Definitive match - Chain is locked and persists in new match runs">book</mat-icon>
        <mat-icon *ngIf="chainStatus?.status === 'selected_for_transplantation' && !areAllPairsConfirmed()" class="status-icon selected-for-transplantation-icon" [class.new-indicator]="isChainStatusNew" [class.reselected]="chainStatus?.wasPreviouslySelected" matTooltip="Selected for transplantation">assignment</mat-icon>
        <mat-icon *ngIf="chainStatus?.status === 'selected_for_transplantation' && areAllPairsConfirmed()" class="status-icon all-confirmed-icon-header" [class.new-indicator]="isChainStatusNew" matTooltip="Transplantation successfully confirmed">check_circle</mat-icon>
        <mat-icon *ngIf="chainStatus?.status === 'transplanted'" class="status-icon transplanted-icon" [class.new-indicator]="isChainStatusNew" matTooltip="Transplanted - Chain is locked and persists in new match runs">assignment_turned_in</mat-icon>
        <mat-icon *ngIf="chainStatus?.status === 'cancelled'" class="status-icon cancelled-icon" [class.new-indicator]="isChainStatusNew" matTooltip="Cancelled - Chain is locked and persists in new match runs">cancel</mat-icon>
        <mat-icon *ngIf="chainStatus?.status === 'unselected_for_transplantation'" class="status-icon unselected-for-transplantation-icon" [class.new-indicator]="isChainStatusNew" [matTooltip]="'Unselected for transplantation: ' + (chainStatus?.unselectReason || 'No reason provided')">assignment_late</mat-icon>
        <mat-icon *ngIf="!chainStatus" class="status-icon unlocked-icon" matTooltip="Chain is unlocked and may change in future match runs">lock_open</mat-icon>
      </div>
    </mat-list-item>
    <mat-list-item>
      <div class="stretch flex-row">
        <div class="flex-row flex-fill">
          <div class="flex-none" style="width: 12px"></div>
          <h3 class="grey flex-fill">Recipient</h3>
          <div class="flex-none" style="width: 36px"></div>
          <h3 class="grey flex-fill">Donor</h3>
        </div>
        <h3 class="grey text-right flex-none" style="width: 212px; padding-right: 33px">Crossmatch</h3>
        <div class="flex-none" style="width: 24px"></div>
      </div>
    </mat-list-item>
    <mat-divider></mat-divider>
    <br />

    <mat-list-item class="transplantrow" *ngFor="let pair of groupedData; let i = index">
      <!-- Separator line between locked and new portions in merged chains -->
      <mat-divider *ngIf="shouldShowMergedChainSeparator(i)" class="merged-chain-separator"></mat-divider>

      <!-- Separator line before alternatives -->
      <mat-divider *ngIf="shouldShowAlternativeSeparator(i)" class="alternative-separator"></mat-divider>

      <div class="stretch flex-row align-center">
        <!-- Recipient Section -->
        <div class="participant-info flex-row align-center recipient-section"
             [class.locked-portion]="isParticipantInLockedPortion(pair.recipient) || isParticipantInFullyLockedChain(pair.recipient)"
             [class.new-portion]="isParticipantInNewPortion(pair.recipient)"
             [class.paired-recipient]="isPairedRecipient(pair.recipient)"
             [class.waitlist-patient]="(isWaitlistPatient(pair.recipient) || isFirstWaitlistRecipient(pair.recipient)) && !isParticipantInFullyLockedChain(pair.recipient)"
             [class.alternative-recipient]="pair.alternative">

          <!-- Special icon for partially locked or merged chain -->
          <mat-icon *ngIf="isParticipantInLockedPortion(pair.recipient)" class="lock-icon-partial">lock_clock</mat-icon>

          <!-- Lock icon for fully locked chain -->
          <mat-icon *ngIf="isParticipantInFullyLockedChain(pair.recipient) && !isParticipantInLockedPortion(pair.recipient)" class="lock-icon-locked">lock</mat-icon>

          <!-- Unlock icon for new portion -->
          <mat-icon *ngIf="isParticipantInNewPortion(pair.recipient)" class="lock-icon-unlocked">lock_open</mat-icon>

          <div class="flex-none" style="width: 64px">{{ pair.recipient?.center?.name }}</div>
          <div class="flex-none" style="width: 64px">{{ pair.recipient?.enisNumber }}</div>
          <!-- Show "Alternative" if the recipient is the alternative recipient -->
          <span *ngIf="pair.alternative">(Alt)</span>

          <div class="flex-fill ellipsis">
            <a href class="participant-name" (click)="openParticipantDialog(pair.recipient, 'recipient'); $event.preventDefault()">{{ pair.recipient?.firstName + " " + pair.recipient?.lastName }}</a>
          </div>
        </div>

        <!-- Chevron Icon - opens side-by-side comparison dialog -->
        <div class="icon-section">
          <button mat-icon-button
                  class="comparison-btn"
                  (click)="openPairComparisonDialog(pair); $event.stopPropagation()"
                  matTooltip="View donor and recipient info side by side">
            <mat-icon>chevron_left</mat-icon>
          </button>
        </div>

        <!-- Donor Section -->
        <div class="participant-info flex-row align-center donor-section"
             [class.locked-portion]="isParticipantInLockedPortion(pair.donor) || isParticipantInFullyLockedChain(pair.donor)"
             [class.new-portion]="isParticipantInNewPortion(pair.donor)"
             [class.partial-lock-donor]="isPartiallyLockedDonor(pair.donor)"
             [class.altruist-donor]="isAltruistDonor(pair.donor) && !isParticipantInLockedPortion(pair.donor) && !isParticipantInFullyLockedChain(pair.donor)"
             [class.alternative-recipient]="pair.alternative">

          <!-- Special icon for locked and merged chains -->
          <mat-icon *ngIf="isPartiallyLockedChain() || isMergedChain()" class="lock-icon-partial" matTooltip="Partially locked donor - Included in algorithm">lock_clock</mat-icon>

          <!-- Lock icon for locked portion (merged chain) -->
          <!-- <mat-icon *ngIf="isParticipantInLockedPortion(pair.donor) && !isPartiallyLockedDonor(pair.donor)" class="lock-icon-locked">lock</mat-icon> -->

          <!-- Lock icon for fully locked chain -->
          <mat-icon *ngIf="isParticipantInFullyLockedChain(pair.donor) && !isPartiallyLockedDonor(pair.donor) && !isParticipantInLockedPortion(pair.donor)" class="lock-icon-locked">lock</mat-icon>

          <!-- Unlock icon for new portion -->
          <!-- <mat-icon *ngIf="isParticipantInNewPortion(pair.donor)" class="lock-icon-unlocked">lock_open</mat-icon> -->

          <div class="flex-none" style="width: 64px">{{ pair.donor?.center?.name }}</div>
          <div class="flex-none" style="width: 64px">{{ pair.donor?.enisNumber }}</div>
          <div class="flex-fill ellipsis">
            <a href class="participant-name" (click)="openParticipantDialog(pair.donor, 'donor'); $event.preventDefault()">{{ pair.donor?.firstName + " " + pair.donor?.lastName }}</a>
          </div>
        </div>

        <!-- Crossmatch Section -->
        <div class="participant-info flex-row align-center crossmatch-section">
          <div class="flex-none" style="width: 32px"><!-- Reduced width for better spacing --></div>
          <div class="flex-fill crossmatch-chips-container">
            <!-- Show crossmatch chips when there are results -->
            <div *ngIf="hasCrossmatch(pair)" class="crossmatch-chips-wrapper">
              <!-- Left side chips (transplant type and excluded) -->
              <mat-chip-set class="crossmatch-chips-left">
                <!-- Show transplant type chip if it exists and user has permission to see it -->
                <mat-chip *ngIf="getTransplantTypeForPair(pair)"
                  [class]="getTransplantTypeClass(getTransplantTypeForPair(pair)!)">
                  {{ getTransplantTypeLabel(getTransplantTypeForPair(pair)!) }}
                </mat-chip>
                <!-- Show excluded combination chip if it exists -->
                <mat-chip *ngIf="hasExcludedCombination(pair)"
                  class="excluded-result"
                  [class.new-crossmatch]="isPairExcludedCombinationNew(pair)"
                  [matTooltip]="getExcludedCombinationTooltip(pair)"
                  matTooltipClass="multiline-tooltip">
                  Excluded
                </mat-chip>
              </mat-chip-set>

              <!-- Right side chips (positive/negative result) -->
              <mat-chip-set class="crossmatch-chips-right" *ngIf="hasCrossmatchResult(pair)">
                <mat-chip
                  [class.positive-result]="getCrossmatchStatus(pair) === 'Positive'"
                  [class.negative-result]="getCrossmatchStatus(pair) === 'Negative'"
                  [class.pending-result]="getCrossmatchStatus(pair) === 'Pending'"
                  [class.new-crossmatch]="isPairCrossmatchResultNew(pair)"
                  [matTooltip]="getCrossmatchResultTooltip(pair)"
                  matTooltipClass="multiline-tooltip">
                  {{ getCrossmatchResultLabel(pair) }}
                </mat-chip>
              </mat-chip-set>
            </div>

            <!-- Show text when no crossmatch exists, but still show transplant type if available -->
            <ng-container *ngIf="!hasCrossmatch(pair)">
              <span class="crossmatch-result">{{ getCrossmatchResult(pair) }}</span>
              <!-- Show transplant type chip even if no crossmatch exists -->
              <mat-chip-set *ngIf="getTransplantTypeForPair(pair)" class="crossmatch-chips-left">
                <mat-chip
                  [class]="getTransplantTypeClass(getTransplantTypeForPair(pair)!)">
                  {{ getTransplantTypeLabel(getTransplantTypeForPair(pair)!) }}
                </mat-chip>
              </mat-chip-set>
            </ng-container>
          </div>
          <!-- Confirm transplantation or crossmatch actions -->
          <div class="flex-none crossmatch-actions-container" *hasPermission="Permission.CROSSMATCH_RESULT_ADD">
            <!-- Show Confirm Transplantation button when chain is selected for transplantation -->
            <div class="confirm-transplant-area" *ngIf="isSelectedForTransplantation() && !isHistoricalMatchRun">
              <!-- Confirm button when not confirmed -->
              <button
                *ngIf="!isPairConfirmed(pair)"
                mat-button
                color="primary"
                (click)="confirmPairTransplantation(pair)"
                matTooltip="Click to confirm transplantation for this pair"
                class="confirm-transplant-button">
                Confirm
              </button>

              <!-- Show green checkmark when confirmed -->
              <div *ngIf="isPairConfirmed(pair)" class="confirmed-state">
                <mat-icon class="confirmed-checkmark" matTooltip="Transplantation successfully confirmed">check_circle</mat-icon>
              </div>
            </div>

            <!-- Show crossmatch actions when chain is not selected for transplantation -->
            <div class="crossmatch-actions" *ngIf="!isSelectedForTransplantation() && !isHistoricalMatchRun">
              <!-- Combined add/delete menu -->
              <button
                mat-icon-button
                color="primary"
                [matMenuTriggerFor]="combinedMenu"
                [disabled]="areCrossmatchActionsDisabled()"
                [matTooltip]="areCrossmatchActionsDisabled() ? 'Cannot modify crossmatches for chains selected for transplantation' : 'Manage crossmatches and exclusions'">
                <!-- Show + icon when nothing exists, otherwise show 3 dots -->
                <mat-icon>{{ hasCrossmatch(pair) ? 'more_vert' : 'add' }}</mat-icon>
              </button>
              
              <mat-menu #combinedMenu="matMenu">
                <!-- ADD OPTIONS -->
                <!-- Show crossmatch options if no crossmatch result exists -->
                <ng-container *ngIf="!hasCrossmatchResult(pair)">
                  <button mat-menu-item (click)="addCrossmatch(pair, 'Positive')" *hasPermission="Permission.MATCHRUN_ADD_CROSSMATCH">
                    <mat-icon style="color: rgb(187, 0, 0);">close</mat-icon>
                    <span>Add Positive Crossmatch</span>
                  </button>
                  <button mat-menu-item (click)="addCrossmatch(pair, 'Negative')" *hasPermission="Permission.MATCHRUN_ADD_CROSSMATCH">
                    <mat-icon style="color: rgba(56, 142, 60);">check</mat-icon>
                    <span>Add Negative Crossmatch</span>
                  </button>
                </ng-container>
                
                <!-- Show excluded combination option if no excluded combination exists -->
                <ng-container *hasPermission="Permission.MATCHRUN_ADD_COMBINATION">
                  <button mat-menu-item (click)="addExcludedCombination(pair)" *ngIf="!hasExcludedCombination(pair)">
                    <mat-icon style="color: rgb(255, 152, 0);">block</mat-icon>
                    <span>Add Excluded Combination</span>
                  </button>
                </ng-container>
                
                <!-- DIVIDER (only show if both add and delete options exist) -->
                <mat-divider *ngIf="(hasCrossmatchResult(pair) || hasExcludedCombination(pair)) && (!hasCrossmatchResult(pair) || !hasExcludedCombination(pair))"></mat-divider>
                
                <!-- DELETE OPTIONS -->
                <!-- Show delete crossmatch if crossmatch exists and user can delete it -->
                <button mat-menu-item (click)="deleteCrossmatch(pair)" *ngIf="hasCrossmatchResult(pair) && canDeleteCrossmatchResult(pair)">
                  <mat-icon style="color: rgb(187, 0, 0);">delete</mat-icon>
                  <span>Delete Crossmatch</span>
                </button>
                
                <!-- Show delete excluded combination if excluded combination exists and user can delete it -->
                <button mat-menu-item (click)="deleteExcludedCombination(pair)" *ngIf="hasExcludedCombination(pair) && canDeleteExcludedCombination(pair)">
                  <mat-icon style="color: rgb(187, 0, 0);">delete</mat-icon>
                  <span>Delete Excluded Combination</span>
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
      </div>
    </mat-list-item>
  </mat-list>

  <!-- Display chain comment if it exists -->
  <div class="chain-comment-section" *ngIf="chainStatus?.comment">
    <mat-divider></mat-divider>
    <div class="chain-comment-header" (click)="toggleChainCommentExpanded()">
      <mat-icon class="comment-icon">comment</mat-icon>
      <span class="comment-title">Chain Comment</span>
      <mat-icon class="expand-icon">{{ isChainCommentExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
    </div>
    <div class="chain-comment-content" *ngIf="isChainCommentExpanded">
      <p class="comment-text">{{ chainStatus?.comment }}</p>
      <div class="comment-meta">
        <span *ngIf="chainStatus?.setBy">Set by: <strong>{{ chainStatus?.setBy }}</strong></span>
      </div>
    </div>
  </div>

  <!-- Bottom action bar -->
  <mat-card-actions class="chain-actions" *hasPermission="Permission.MATCHRUN_SETTINGS">
    <!-- Left side: Add/Edit comment button for non-locked chains -->
    <div class="left-actions">
      <button
        *ngIf="!isChainLocked() && !isHistoricalMatchRun"
        mat-icon-button
        (click)="openCommentDialog()"
        [matTooltip]="chainStatus?.comment ? 'Edit comment' : 'Add comment'"
        class="comment-button">
        <mat-icon>{{ chainStatus?.comment ? 'edit' : 'add' }}</mat-icon>
      </button>
    </div>

    <!-- Right side: Chain status actions -->
    <div class="right-actions">
    <!-- Show "Select for Transplantation" text if chain is not selected and not historical -->
    <div
      *ngIf="!isSelectedForTransplantation() && chainStatus?.status !== 'transplanted' && !isHistoricalMatchRun && !isUnselectedForTransplantation()"
      [class.select-transplant-text]="true"
      [class.disabled]="!canSelectForTransplantation()"
      [class.enabled]="canSelectForTransplantation()"
      (click)="canSelectForTransplantation() ? selectForTransplantation() : null"
      [matTooltip]="getSelectForTransplantationTooltip()"
      matTooltipPosition="above">
      <mat-icon>assignment</mat-icon>
      <span>SELECT FOR TRANSPLANTATION</span>
    </div>

    <!-- Show "Unselect Transplant" button when selected but not all pairs confirmed -->
    <ng-container *ngIf="isSelectedForTransplantation() && !isHistoricalMatchRun && !areAllPairsConfirmed()">
      <button
        mat-button
        color="warn"
        (click)="unselectForTransplantation()"
        class="unselect-transplant-button">
        <mat-icon>cancel</mat-icon>
        <span>UNSELECT TRANSPLANT</span>
      </button>
    </ng-container>

    <!-- Merged chain actions -->
    <ng-container *ngIf="isMergedChain() && !isHistoricalMatchRun && !isSelectedForTransplantation()">
      <button
        mat-button
        [matMenuTriggerFor]="mergedLockMenu"
        color="primary"
        class="lock-button">
        <mat-icon>lock</mat-icon>
        <span>LOCKING</span>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #mergedLockMenu="matMenu">
        <button mat-menu-item (click)="lockEntireMergedChain()">
          <mat-icon>lock</mat-icon>
          <span>Lock entire chain</span>
        </button>
        <button mat-menu-item (click)="unlockEntireChain()">
          <mat-icon>lock_open</mat-icon>
          <span>Unlock</span>
        </button>
      </mat-menu>
    </ng-container>

    <!-- Partial lock actions -->
    <ng-container *ngIf="isPartiallyLockedChain() && !isHistoricalMatchRun && !isSelectedForTransplantation()">
      <button
        mat-button
        color="warn"
        (click)="unlockEntireChain()"
        class="unlock-button">
        <mat-icon>lock_open</mat-icon>
        <span>UNLOCK</span>
      </button>
    </ng-container>

    <!-- Lock options menu for altruistic chains with waitlist -->
    <button
      *ngIf="isAltruisticChainWithWaitlist() && !isChainLocked() && !isHistoricalMatchRun && !isSelectedForTransplantation()"
      mat-button
      [matMenuTriggerFor]="lockMenu"
      class="lock-button">
      <mat-icon>lock</mat-icon>
      <span>LOCK</span>
      <mat-icon>arrow_drop_down</mat-icon>
    </button>

    <mat-menu #lockMenu="matMenu">
      <button mat-menu-item (click)="toggleChainLock()">
        <mat-icon>lock</mat-icon>
        <span>LOCK ENTIRE CHAIN</span>
      </button>
      <button mat-menu-item (click)="lockChainUpToWaitlist()">
        <mat-icon>lock_clock</mat-icon>
        <span>LOCK UP TO WAITLIST</span>
      </button>
    </mat-menu>

    <!-- Show lock/unlock button for other statuses (not merged/partial/altruistic) -->
    <!-- Regular lock/unlock button for chains that are NOT merged or partial -->
    <!-- Show for altruistic chains with waitlist ONLY if they are already fully locked -->
    <button
      *ngIf="!isSelectedForTransplantation() && !isMergedChain() && !isPartiallyLockedChain() && (!isAltruisticChainWithWaitlist() || isChainLocked()) && chainStatus?.status !== 'transplanted' && !isHistoricalMatchRun"
      mat-button
      (click)="toggleChainLock()"
      class="lock-button">
      <mat-icon>{{ isChainLocked() ? 'lock_open' : 'lock' }}</mat-icon>
      <span>{{ isChainLocked() ? 'UNLOCK' : 'LOCK' }}</span>
    </button>

    <!-- Show message for transplanted chains -->
    <span *ngIf="chainStatus?.status === 'transplanted'" class="transplanted-message">
      <mat-icon class="transplanted-lock-icon">lock</mat-icon>
      Permanently locked (Transplanted)
    </span>
    <!-- Show message for historical matchruns -->
    <span *ngIf="isHistoricalMatchRun && chainStatus?.status !== 'transplanted'" class="historical-message">
      <mat-icon class="historical-icon">history</mat-icon>
      Historical matchrun (Read-only)
    </span>
    </div> <!-- Close right-actions -->
  </mat-card-actions>
</mat-card>

<!--<div class="flex-none" >
              <mat-icon  matTooltip="Transplanted">assignment_turned_in</mat-icon>
              <mat-icon  matTooltip="Participant removed from program">assignment_late</mat-icon>
            </div>
           <ng-container *ngIf="txp.altruisticCenter">
              <div class="flex-none" style="width: 64px">{{ txp.altruisticCenter }}</div>
              <div class="flex-fill mat-body-1">anyone</div>
            </ng-container>-->

<!--<div class="flex-none" [ngSwitch]="txp.donorTransplanted">
              <mat-icon *ngSwitchCase="true" matTooltip="Transplanted">assignment_turned_in</mat-icon>
              <mat-icon *ngSwitchCase="'unknown'" matTooltip="Participant removed from program">assignment_late</mat-icon>
            </div> -->

<!--<mat-chip *ngIf="mayAdd && txp.exclusion && txp.exclusion.result !== 'undetermined'">
            <div class="flex-row" [class]="txp.exclusion.result">
              <div class="flex-fill"></div>
              <mat-chip
                matTooltip="registration date: {{ (txp.exclusion.dateEntered | date: 'd MMM yyyy') || 'unknown' }}, sample date: {{ (txp.exclusion.sampleDate | date: 'd MMM yyyy') || 'unknown' }}"
                class="mat-elevation-z1"
              >
                {{ txp.exclusion.result }}
              </mat-chip>
            </div>
          </mat-chip> -->
